import styled from 'styled-components';

const ChildMenuContainer = styled.div`
  background-color: var(--white);
  height: 100%;
  width: 100%;
  border-top: 1px solid #dfe0e1;
  position: absolute;
  top: 0;
`;

const NavItemsContainer = styled.div`
  .group-label {
    color: var(--titan-blue-3);
    margin: 0;
    padding: ${({ index }) => (index !== 0 ? '40px 30px 0' : '30px 30px 0')};

    span {
      padding: 4px 7px 2px 7px;
      border-radius: 4px;
      background: var(--titan-blue-3);
      color: var(--white);
      margin-left: 3px;
    }
  }
`;

const NavItem = styled.div`
  background-color: var(--white);
  width: 100%;
  padding: 30px 30px 0;
  display: flex;
  flexdirection: row;

  .styles-container {
    width: max-content;
  }

  img,
  .website-image {
    margin-right: 15px;
  }

  .nav-item-label {
    margin: 0;
    position: relative;

    b {
      font-weight: 500;
    }

    .beta {
      color: #3f2b94;
      background: #f1edfe;
      border-radius: 4px;
      font-weight: 500;
      margin-left: 8px;
      font-size: 13px;
      padding: 0px 6px;
      position: absolute;
      top: -1px;
      height: 21px;
      right: -47px;
    }
  }
`;

const ButtonsContainer = styled.div`
  padding: 30px;
  width: 100%;
  &.top-btn {
    padding-bottom: 10px;
  }

  button,
  a {
    width: 100%;
    border-radius: 2px !important;
    p {
      margin: 2px 0 0;
    }
  }
`;

export { ChildMenuContainer, NavItemsContainer, NavItem, ButtonsContainer };
